window.summary = { total: 0.00, subtotal: 0.00, tax: 0.00, shipping: 0.00, state_specific_purchase_fee: 0.00 };
window.checkoutIsDirty = true;

var $parsley, $form, $sameAs, $buttons, $email;
var dropinInstance;
var recaptchaLastTokenTimestamp = 0;

// http://krasimirtsonev.com/blog/article/Javascript-template-engine-in-just-20-line
var TemplateEngine = function(html, options) {
  var re = /<%(.+?)%>/g,
    reExp = /(^( )?(var|if|for|else|switch|case|break|{|}|;))(.*)?/g,
    code = 'with(obj) { var r=[];\n',
    cursor = 0,
    result,
    match;
  var add = function(line, js) {
    js? (code += line.match(reExp) ? line + '\n' : 'r.push(' + line + ');\n') :
        (code += line != '' ? 'r.push("' + line.replace(/"/g, '\\"') + '");\n' : '');
    return add;
  }
  while(match = re.exec(html)) {
    add(html.slice(cursor, match.index))(match[1], true);
    cursor = match.index + match[0].length;
  }
  add(html.substr(cursor, html.length - cursor));
  code = (code + 'return r.join(""); }').replace(/[\r\t\n]/g, ' ');
  try { result = new Function('obj', code).apply(options, [options]); }
  catch(err) { console.error("'" + err.message + "'", " in \n\nCode:\n", code, "\n"); }
  return result;
}

var addressTemplate = '<div class="checkout-address"> ' +
  '<span><%this.first_name%> <%this.last_name%></span> ' +
  '<%if(this.address_3){%><span><%this.address_3%></span> <%}%>' +
  '<%if(this.inmate_number){%><span><%this.inmate_number%></span> <%}%>' +
  '<%if(this.company_name){%><span><%this.company_name%></span> <%}%>' +
  '<span><%this.address%></span> ' +
  '<%if(this.address_2){%><span><%this.address_2%></span> <%}%>' +
  '<span><%this.city%>, <%this.state%> <%this.postal_code%></span> ' +
  '<%if(this.email){%><span>Email: <%this.email%></span> <%}%>' +
  '</div>';

var paymentTemplate = '<div class="checkout-address"> ' +
  '<%if(this.method === "PayPalAccount"){%>' +
      '<span>Method: PayPal</span>' +
      '<span>Account: <%this.email%></span>' +
  '<%}else{%>' +
      '<span>Method: Credit Card</span> ' +
      '<span>Card Type: <%this.card_type%></span> ' +
      '<span>Last Four: <%this.last_four%></span> ' +
      '<span>Expiration: <%this.expiration%></span> ' +
  '<%}%>' +
  '</div>';

var summaryRowTemplate = '<tr<%if(this.c){%> class="<%this.c%>"<%}%>>' +
  '<td class="col-1"><%this.l%>:</td>' +
  '<td class="price-total-column col-2">' +
      '<span class="the-price">$<%this.v%></span>' +
  '</td>' +
  '</tr>';

var totalsRowTemplate = '<tr<%if(this.c){%> class="<%this.c%>"<%}%>>' +
  '<td class="label-column col-1" colspan="2"><%this.l%>:</td>' +
  '<td class="price-total-column col-2">' +
      '<span class="cart-mobile-label"><%this.l%>:</span>' +
      '<span class="the-price">$<%this.v%></span>' +
  '</td>' +
  '</tr>';

var alertTemplate = '<div id="checkout-alert" class="alert alert--error fade in">' +
      '<%this.message%>' +
  '</div>';


(function(namespace) { // Closure to protect local variable "var hash"
  if ('replaceState' in history) { // Yay, supported!
    namespace.replaceHash = function(newhash) {
      if((''+newhash).charAt(0) !== '#'){
        newhash = '#' + newhash;
      }
      history.replaceState('', '', newhash);
    }
  } else {
    var hash = location.hash;
    namespace.replaceHash = function(newhash) {
      if(location.hash !== hash){
        history.back();
      }
      location.hash = newhash;
    };
  }
})(window);

function repeat(str, n) {
  if(!String.prototype.repeat) {
    n = n || 1;
    return Array(n+1).join(str);
  }

  return str.repeat( n );
}

function renameObjectKeys(obj, strip, purge) {
  purge = !!purge;
  strip = !!strip ? strip : '';

  Object.keys(obj).forEach(function(key){
    var replace = key.replace(RegExp(strip), '');

    if(obj.hasOwnProperty(key)) {
      // ignore keys that don't change
      if(key === replace) {
        return;
      }
      // purge empty keys
      if(purge && (obj[key] === null || obj[key] === '')) {
        delete obj[key];
        return;
      }
      // replace key
      obj[replace] = obj[key];
      delete obj[key];
    }
  });

  return obj;
}

window.onload = function(){
  $.ajaxSetup({
    cache: false
  });

  $form = $('#checkout-form');

  (function($){
      $.fn.preventReturnSubmit = function(options) {
          options = $.extend({}, {'child': null}, options);

          function preventReturn(event){
              var code = event.keyCode || event.which;
              if(code === 13) {
                  event.preventDefault();
                  return false;
              }
          }

          return this.each(function(){
              if(options.child) {
                  $(this).on('keypress', options.child, preventReturn);
              } else {
                  $(this).on('keypress', preventReturn);
              }
          });
      };

      $.fn.serializeObject = function() {
          var o = {};
          var a = this.serializeArray();
          $.each(a, function() {
              if (o[this.name]) {
                  if (!o[this.name].push) {
                      o[this.name] = [o[this.name]];
                  }
                  o[this.name].push(this.value || '');
              } else {
                  o[this.name] = this.value || '';
              }
          });
          return o;
      };

    if($form.length) {
      $form.preventReturnSubmit({child: ':input, :button'});
    }
  })(window.jQuery);


  if($form.length) {
    $email = $('#bill_to_email');

    initBraintree(function() {
      initForm( initParsley );
      initCheckoutTabs( initHashTab );
    });
  }
};

function initBraintree(callback) {
  braintree.dropin.create({
    authorization: window.BRAINTREE_CLIENT_TOKEN,
    container: '#dropin-container',
    dataCollector: true,
    card: {
      cardholderName: {
        required: true,
      },
      overrides: {
        fields: {
          cvv: {
            placeholder: '',
          },
        },
      },
    },
    paypal: {
      flow: 'vault',
      amount: 0.00,
      commit: false,
      currency: 'USD',
      intent: 'authorize',
      buttonStyle: {
        label: 'paypal',
        layout: 'horizontal',
        color: 'gold',
        shape: 'rect',
        size: 'large',
      },
      enableShippingAddress: false,
      shippingAddressEditable: false,
    },
  }, function(createErr, instance) {
    if(createErr) {
      showErrorAlert('.checkout-loading', 'Checkout initialization failed. Please refresh the page and try again.');
      return;
    }

    $('#continue-confirm').prop('disabled', true);

    // instance.on('card:validityChange', function(event) {
    //   // console.log('card:validityChange', event);
    //   var cardInvalid = Object.values(event.fields).filter(function(field) {
    //     return !field.isValid;
    //   }).length > 0

    //   //
    // });

    instance.on('noPaymentMethodRequestable', function(event) {
      // disable continuing
      // console.log('none requestable', event);

      $('#continue-confirm').prop('disabled', true);
    });

    instance.on('paymentMethodRequestable', function(event) {
      // enable continuing
      // console.log('paymentMethodRequestable', event);

      $('#continue-confirm').prop('disabled', false);
    });

    dropinInstance = instance;

    if(typeof callback === 'function') {
      callback();
    }
  });
}


function initForm(callback) {
  $sameAs        = $('#same_as_bill_to, #same_as_ship_to');
  $buttons       = $('.checkout-submit-btn');

  $form
    .on('click', '.aft-step, .fore-step', function(event){
      event.preventDefault();

      $form.find('.alert').remove();

      var $me = $(this);
      if($me.hasClass('fore-step') && !validatePanel( $me.closest('.checkout-panel').attr('id') )) {
        return false; // don't proceed
      }

      if($me.attr('data-target-panel').indexOf('#') === 0) {
        // clear confirm error message
        $form.find('#confirm-panel').find('.alert').remove();

        updateConfirmation();

        var jumpTo = $me.attr('data-target-panel');
        if($me.attr('data-address') === 'bill' && $me.hasClass('fore-step') && sameAsBillTo()) {
          jumpTo = '#payment-panel';
        } else if($me.attr('data-address') === 'payment' && $me.hasClass('aft-step') && sameAsBillTo()) {
          jumpTo = '#billing-panel';
        }
        $('.checkout-tabs [href="'+jumpTo+'"]').tab('show');

        if(jumpTo === '#payment-panel' || jumpTo === '#confirm-panel') {
          reloadSummary();
        }
      }
    })
    .on('click', '.edit-step', function(event){
      var $me = $(this);
      if($me.attr('data-target-panel').indexOf('#') === 0) {
        event.preventDefault();

        // clear confirm error message
        $form.find('#confirm-panel').find('.alert').remove();

        $('.checkout-tabs [href="'+$me.attr('data-target-panel')+'"]').tab('show');
      }
    })
    .on('change', '.recalc', function(){
      window.checkoutIsDirty = true; //reloadSummary();
    })

    .on('submit', function(event){
      event.preventDefault();

      toggleSubmitButtons(true);

      var nowTimestamp = new Date().getTime();

      if(
        (nowTimestamp - recaptchaLastTokenTimestamp) > 100000
        || !document.getElementById('g-response').value
      ){
        grecaptcha.ready(function(){
            grecaptcha.execute(
                window.recaptcha_key,
                {action: 'submit'}
            ).then(function(token) {
                document.getElementById('g-response').value = token;

                recaptchaLastTokenTimestamp = new Date().getTime();

                checkoutSubmit.call(this);
            });
        });
      } else {
        checkoutSubmit.call(this);
      }
    });

  // persist fake items
  $context_closer.on('change', function(){
    disableContextFields.call(this);
  }).trigger('change');

  updateConfirmation();
  reloadSummary();

  $sameAs.on('input', function(){
    $sameAs.prop('checked', this.checked).trigger('change');
  });

  if(typeof callback === 'function') {
    callback();
  }
}

function initParsley() {
  $parsley = $form.parsley({
      excluded: 'input[type=button], input[type=submit], input[type=reset], input[type=hidden], [disabled], #dropin-container input'
      // ,errorsMessagesDisabled: true
    })
    .on('form:error', function(){
      // only trigger on submit of form
      if(this.hasOwnProperty('submitEvent') && this.submitEvent !== undefined) {
        if(this.submitEvent.hasOwnProperty('type') && this.submitEvent.type === 'submit') {
          jumpToError();
        }
      }
    })
    .on('form:submit', function() {
      return validatePanel('confirm');
    });
}


function initCheckoutTabs(callback) {
  $('.checkout-tabs a[data-toggle="tab"]').on('show.bs.tab', function(ev){
    var panel = $(this).attr('data-panel');
    window.replaceHash(panel);

    logroll('switch_to_' + panel);

    // scroll to steps
    $('html, body').animate({
      scrollTop: $('#checkout-steps').offset().top
    }, 500);

    var $current = $('#checkout-steps .checkout-steps-item.'+panel+'-step')
    $current.addClass('current-checkout-step')
      .siblings('.current-checkout-step').removeClass('current-checkout-step');

    $current.prevUntil('.untracked')
      .addClass('complete-checkout-step');

    $current.nextAll('.checkout-steps-item')
      .removeClass('complete-checkout-step');
  });

  if(typeof callback === 'function') {
    callback();
  }
}

function initHashTab() {
  var hash = window.location.hash.substr(1);
  if(hash != '' && $('.checkout-tabs [data-panel="'+hash+'"]').length) {
    if(
      (hash === 'shipping' && validatePanel('billing-panel'))
      || (hash === 'payment' && validatePanel('billing-panel') && validatePanel('shipping-panel'))
      || (hash === 'confirm' && validatePanel())
    ) {
      if(hash === 'confirm' && !window.hasOwnProperty('paypalExpress')) {
        hash = 'payment';
      }
      $('.checkout-tabs [data-panel="'+hash+'"]').tab('show');
    }
  }

  if($('.parsley-error').length) {
    jumpToError(true);
  }

  if(!$('html').hasClass('checkout-tabs-init')) {
    $('html').addClass('checkout-tabs-init');
  }
}


function validatePanel(panel_id) {
  switch(panel_id) {
    case 'billing-panel':
      if($parsley.validate({group: 'billing'})) {
        return true;
      }
      break;
    case 'shipping-panel':
      if($parsley.validate({group: 'shipping'})) {
        return true;
      }
      break;
    case 'payment-panel':
      if(dropinInstance.isPaymentMethodRequestable()) {
        dropinInstance.requestPaymentMethod(function(err, payload) {
          // console.log('requestPaymentMethod', err, payload);

          if(err) {
            //
            return;
          }

          $('#payment_nonce').val(payload.nonce);
          $('#device_data').val(payload.deviceData);
          $('#payment_method').val(payload.type);

          if(payload.type == 'CreditCard') {
            $('#card_type').val(payload.details.cardType);
          }

          persistPayment(payload.type, payload.details);
        });

        return true;
      }

      break;
    default: // confirm?
      $parsley.validate();
      return $parsley.isValid() && dropinInstance.isPaymentMethodRequestable();
  }

  return false;
}


function persistAddress(retrieve, populate) {
  populate = !!populate ? populate : retrieve;

  if(retrieve === 'ship' && sameAsBillTo()) {
      retrieve = 'bill';
  }
  var data = $('#'+retrieve+'_to_fields :input').serializeObject();
  var address = renameObjectKeys(data, retrieve+'_to_');

  if(populate === 'ship') {
    delete address.email;
  }

  $('#confirm-' + (populate === 'bill' ? 'billing' : 'shipping') + '-address')
    .html( TemplateEngine(addressTemplate, address) );
}


function persistPayment(type, details) {
  $('#confirm-payment').html(
    TemplateEngine(paymentTemplate, {
      method: type,
      email: details.email,
      card_type: details.cardType,
      expiration: details.expirationMonth + '/' + details.expirationYear,
      last_four: details.lastFour,
    })
  );
}


function reloadSummary(retryCount) {
    if(!window.checkoutIsDirty) return;

    retryCount = retryCount === undefined ? 0 : retryCount;
    if(retryCount > 2) {
        alert('An error occurred while processing your request.');
        return;
    }

    toggleSubmitButtons(true);

    var address = $('#' + (!sameAsBillTo() ? 'ship_to_fields' : 'bill_to_fields')).find(':input').serializeObject();

    var formData = {
        _token: $('#_tokenCheck').val(),
        address: address
    };

    $.post('/checkout/ajax/summary', formData, null, 'json')
        .always(function(){
            toggleSubmitButtons(false);
        })
        .fail(function(xhr, status){
            retryCount++;
            reloadSummary(retryCount);
        })
        .done(function(response){
            if(response.hasOwnProperty('summary')) {
                window.summary = response.summary;

                dropinInstance && dropinInstance.updateConfiguration('paypal', 'amount', window.summary.total);

                if(
                  response.summary.tax_postal_code
                  && response.summary.tax_postal_code.length >= 5
                ) {
                  var pcField = (sameAsBillTo() ? 'bill' : 'ship') + '_to_postal_code';

                  document.getElementById(pcField).value = response.summary.tax_postal_code;
                }
            }
            if(response.hasOwnProperty('sidebar') && response.sidebar.length) {
                var sidebar;

                response.sidebar.forEach(function(item){
                    sidebar += TemplateEngine(summaryRowTemplate, item);
                });
                $('#checkout-summary tbody').html(sidebar);
            }
            if(response.hasOwnProperty('foot') && response.foot.length) {
                var foot;
                response.foot.forEach(function(item){
                    foot += TemplateEngine(summaryRowTemplate, item);
                });
                $('#checkout-summary tfoot').html(foot);
            }
            if(response.hasOwnProperty('order') && response.order.length) {
                var order;
                response.order.forEach(function(item){
                    order += TemplateEngine(totalsRowTemplate, item);
                });
                $('#checkout-order-totals').html(order);
            }

            window.checkoutIsDirty = false;
        });
}


function checkoutSubmit() {
  toggleSubmitButtons(true);
  $form.find('.alert').remove();

  logroll('checkout_submit');

  dropinInstance.requestPaymentMethod(function(err, payload) {
    if(err) {
      //
      toggleSubmitButtons(false);

      return;
    }

    $('#payment_nonce').val(payload.nonce);
    $('#device_data').val(payload.deviceData);

    $form[0].submit();
  });
}

function updateConfirmation() {
  persistAddress('bill');
  persistAddress('ship');
}

function sameAsBillTo() {
  return !! $sameAs.filter(':checked').length;
}

function disableContextFields() {
  var context, opener, closer;

  context = (closer = this.getAttribute('data-context-to-close-id'))
              || (opener = this.getAttribute('data-context-to-open-id'));

  $('#'+context).find(':input')
    .prop('disabled', this.checked && !opener )
    .parsley('reset');
}

function toggleSubmitButtons(state) {
  $buttons
    .prop('disabled', !!state)
    .toggleClass('processing', !!state);
}

function jumpToError(trigger) {
  var id = $('.parsley-error:first').closest('.checkout-panel').attr('id');
  var tab = $('.checkout-tabs [href="#'+id+'"]');
      tab.tab('show');
  if(trigger !== undefined && trigger === true) {
    tab.trigger('show.bs.tab');
  }
}

function showErrorAlert(target, message) {
  $('#checkout-alert').remove();

  $(target).after(
    TemplateEngine(alertTemplate, {message: message})
  );

  $('html, body').animate({
    scrollTop: $('#checkout-alert').offset().top
  }, 500);
}

function logroll(action, data) {
  try {
    $.post('/checkout/logroll', {
      'action': action,
      'email': $email.val(),
      'data': data
    });
  } catch(e) {}
}
